export const MODULES = [
  { key: "dashboard", label: "Dashboard" },
  { key: "profile", label: "My Profile" },
  { key: "invoice", label: "Invoice" },
  { key: "purchase", label: "URD Purchase" },
  { key: "stock", label: "Stock" },

  { key: "category master", label: "Category Master" },
  { key: "product master", label: "Product Master" },
  { key: "design master", label: "Design Master" },
  { key: "purity master", label: "Purity Master" },
  { key: "stone master", label: "Stone Master" },
  { key: "diamond master", label: "Diamond Master" },
  { key: "rate master", label: "Rate Master" },
  { key: "attribute master", label: "Attribute Master" },
  { key: "other master", label: "Other Masters" },

  { key: "company", label: "Company" },
  { key: "branch", label: "Branch" },
  { key: "counter", label: "Counter" },
  { key: "role", label: "Role" },
  { key: "department", label: "Department" },
  { key: "bank", label: "Bank" },
  { key: "rfid", label: "RFID" },
  { key: "vendor", label: "Vendor" },
  { key: "customer", label: "Customer" },
  { key: "employee", label: "Employee" },

  { key: "stock Report", label: "Stock Report" },
  { key: "urd report", label: "URD Purchase Report" },
  { key: "sale report", label: "Sale Report" },
  { key: "gst report", label: "GST Report" },
  { key: "deleted invoice report", label: "Deleted Invoices Report" },
  { key: "o/s report", label: "O/s Report" },
  { key: "wallet report", label: "Wallet Report" },
  { key: "cash report", label: "Cash Report" },
  { key: "stock transfers", label: "Stock Transfers" },

  { key: "user Management", label: "User Management" },
  { key: "customer transaction", label: "Customer Transaction" },
  { key: "label editor", label: "Label Editor" },
  { key: "quotation", label: "Quotation" },
  { key: "scheme", label: "Scheme" },
  { key: "scheme enrollment", label: "Scheme Enrollment" },
  { key: "item detail", label: "Item Detail View" },
  { key: "estimate", label: "Estimate" },
  { key: "stock verification", label: "Stock Verification" },
  { key: "gst return report", label: "Gst Return Report" },
  { key: "setting", label: "Settings" },
  { key: "whatsapp commerce", label: "WhatsApp Commerce" },
];

export const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Puducherry",
  "Chandigarh",
  "Andaman and Nicobar Islands",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Lakshadweep",
];
